import React, { useEffect, useState } from 'react';
import { Info, X } from 'lucide-react';
import { FaTimes } from 'react-icons/fa';
import server from '../../api/server';
import "../loader.css"
import { useToast } from '../../context/ToastContext.jsx';

const CreateProjectModal = ({ isOpen, onClose, onCreateProject, clientID, email, allow }) => {
  const { showToast } = useToast();
  const [projectName, setProjectName] = useState('');
  const [projectContext, setProjectContext] = useState('');
  const [organizationContext, setOrganizationContext] = useState('');
  const [knowledgeBase, setKnowledgebase] = useState('');
  const [client_id, setClient_id] = useState(null)
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  function getCookie(name) {
    function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : null;
}
  const [role] = useState(()=> {
    const userCookie = getCookie('dashboard_login_user_creds');
    if (userCookie) {
      const userData = JSON.parse(userCookie);
      const role = userData.role
      return role
    }
    return 'admin';
  })
  const [userEmail, setUserEmail] = useState(null)
  const handleChangeProj = (e) => {
    const value = e.target.value;
    const alphanumericWithSpaceRegex = /^[a-zA-Z0-9 ]*$/;
    
    if (!alphanumericWithSpaceRegex.test(value)) {
      setError("Only alphanumeric characters and spaces are allowed");
      return;
    }
    
    if (value.length <= 30) {
      setProjectName(value.toUpperCase());
      setError(""); // Clear error when within limit
    } else {
      setError("Maximum 30 characters allowed");
    }
};
const handleCreateProject = async (e) => {
  if(!e.projectName || !e.projectContext || !e.organizationContext || !e.knowledgeBase){
    showToast('Please fill all fields.', "error");
    return;
  }
  const trimmedProjectName = e.projectName.trim();
  try {
    setLoading(true)
    let obj = {client_id, 'service_id': null, role, menu: 'home', submenu: undefined, 'email': userEmail, project_name: trimmedProjectName, project_context: e.projectContext, organization_context: e.organizationContext, knowledge_base: e.knowledgeBase}
    let res = await server.createProject(obj)
    if(res.status === 200){
      onCreateProject(trimmedProjectName)
      setKnowledgebase('')
      setOrganizationContext('')
      setProjectContext('')
      setProjectName('')
      setError('')
    }else{
      let resp = await res.json()
      setError(resp.error)
    }
    setLoading(false)
  } catch (error) {
    setLoading(false)
  }
}

  const handleSubmit = (e) => {
    e.preventDefault();
      handleCreateProject({
        projectName,
        projectContext,
        organizationContext,
        knowledgeBase
      });
  };
  const handleClose = () => {
    if(allow === false){
      return;
    }
    setKnowledgebase('')
    setOrganizationContext('')
    setProjectContext('')
    setProjectName('')
    onClose()
  }
  useEffect(()=> {
    if(clientID){
      setClient_id(clientID)
    }
    if(email){
      setUserEmail(email)
    }
  }, [clientID, email])


  return (
    <div className="modal-overlay">
      <div className="modal-container">
          <div style={{display: "flex", justifyContent: "space-between"}}>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Create Project</h2>
            {allow && <FaTimes onClick={handleClose} style={{color: "slategray", cursor: "pointer"}}/>}
          </div>
          <hr style={{marginTop: "10px", marginBottom: "10px"}}/>
        {!loading && <form className="modal-content">

          <div className="form-group">
            <label htmlFor="projectName" className='flex items-center'>Project Name <div className="ml-1 relative">
                    <div className="group">
                      <Info className="h-4 w-4 text-gray-500 cursor-help" />
                      <div className="absolute left-0 top-full mt-1 w-64 bg-white border border-gray-200 shadow-sm text-gray-700 text-xs rounded py-2 px-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 pointer-events-none">
                        Project name can't be changed & should be less than 30 characters
                      </div>
                    </div>
                  </div></label>
            <input class="global-input"type="text"
              id="projectName"
              value={projectName}
              onChange={handleChangeProj}
            />
          </div>
          {
            error!=="" && (
              <div style={{fontSize: "12px", color: "red"}}>{error}</div>
            )
          }

          <div className="form-group">
            <label htmlFor="organizationContext">Organization Context</label>
            <textarea class="global-input"
              id="organizationContext"
              value={organizationContext}
              onChange={(e) => setOrganizationContext(e.target.value)}
              rows="2"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="projectContext">Project Context</label>
            <textarea class="global-input"
              id="projectContext"
              value={projectContext}
              onChange={(e) => setProjectContext(e.target.value)}
              rows="4"
            />
          </div>
          
          
          <div className="form-group">
            <label htmlFor="knowledgeBase">Knowledge Base</label>
            <textarea class="global-input"
              id="knowledgeBase"
              value={knowledgeBase}
              onChange={(e) => setKnowledgebase(e.target.value)}
              rows="6"
            />
          </div>
          
        </form>}
        {
          loading && (
            <div className="flex justify-center items-center" style={{ height: "75vh", flexDirection: "column" }}>
                            <div className="loader"></div>
                            <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                        </div>
          )
        }
        <hr style={{marginTop: "10px", marginBottom: "10px"}}/>
          <div className="modal-actions">
            {allow && <button 
              type="button" 
              className="btn-cancel"
              onClick={handleClose}
            >
              Cancel
            </button>}
            <button onClick={handleSubmit} disabled={loading}
              type="submit" 
              className={`btn-create ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'}`}
            >
              Create
            </button>
          </div>
      </div>
      
      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          backdrop-filter: blur(11px);
        }
        
        .modal-container {
          background: white;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          width: 100%;
          max-width: 800px;
          padding: 15px;
          overflow: auto;
        }
        
        .modal-content {
          display: flex;
          flex-direction: column;
          gap: 15px;
          height: 75vh;
          overflow: auto;
        }
        
        .modal-title {
          text-align: center;
          font-size: 1.2rem;
        }
        
        .form-group {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        
        .form-group label {
          font-weight: 500;
          font-size: 14px;
        }
        
        .form-group input,
        .form-group textarea {
          padding: 4px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 1rem;
        }
        
        .modal-actions {
          display: flex;
          justify-content: end;
          margin-top: 20px;
          gap: 15px;
        }
        
        .btn-cancel {
          padding: 5px 20px;
          border: 1px solid #ddd;
          background: white;
          border-radius: 4px;
          cursor: pointer;
        }
        
        .btn-create {
          padding: 5px 20px;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default CreateProjectModal